export default __webpack_public_path__ + "static/media/block4prd2.522436d7.svg";